export class ElementTypes {
  static readonly Autocomplete = 'autocomplete';
  static readonly Button = 'button';
  static readonly Checkbox = 'checkbox';
  static readonly Custom = 'custom';
  static readonly DatePicker = 'date-picker';
  static readonly Div = 'div';
  static readonly Dropdown = 'dropdown';
  static readonly Form = 'form';
  static readonly Host = 'host';
  static readonly Input = 'input';
  static readonly Label = 'label';
  static readonly Link = 'link';
  static readonly Paragraph = 'paragraph';
  static readonly RadioButton = 'radio-button';
  static readonly Span = 'span';
}
